import styled from 'styled-components'

export const StyleDownload = styled.div`
  margin-bottom: 60px;
  margin-top: 180px;
  display: block;
  width: 100%;
  @media screen and (min-width: 300px) and (max-width: 768px) {
    display: none;
  }
`
export const StyleCardJoin = styled.div`
  margin-bottom: 60px;
  margin-top: 180px;
  display: block;
  width: 100%;
  @media screen and (min-width: 300px) and (max-width: 768px) {
    display: none;
  }
`
